import React from 'react'
import {Form, Button, Dropdown, Modal, Image, Label} from 'semantic-ui-react'
import {createAPIClient} from '../../../../../../services/api'

const {Field} = Form
const modalStyle = { marginTop: '5%', marginLeft: 'auto', marginRight: 'auto'}
const confirmStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}

class PlanEdit extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      openConfirm: false,
      postSuccess: false,
      error: undefined,
      isLoading: false,
      updatedPlan: 'free',
      updatedDeviceCount: 10,
      updatedPaymentMethod: 'monthly'
    }
  }
  showConfirm () {
    this.setState({openConfirm: true})
  }
  handleCancel () {
    this.setState({openConfirm: false})
  }
  handleConfirm () {
    const api = createAPIClient()
    api.delete(`/api/templates/${this.state.template.id}`)
      .then(response => {
        this.setState({openConfirm: false})
        this.props.finishPlanChange(true)
      })
      .catch(error => {
        console.log(error)
      })
  }
  cancelEdit () {
    this.props.finishPlanChange(false)
  }

  onEditFormSubmit () {

    const api = createAPIClient()
    if (!this.state.updatedPlan) return
    const form = {
      plan: this.state.updatedPlan,
      deviceCount: this.state.updatedDeviceCount,
      paymentMethod: this.state.updatedPaymentMethod
    }
    this.setState({
      isLoading: true
    })
    api.post('/api/billing/updateplan', form)
      .then(response => {
        this.setState({
          isLoading: false
        })
        this.props.finishPlanChange(true)
      })
      .catch(error => {
        this.setState({
          isLoading: false
        })
        console.log(error)
      })
  }
  onPlanSelection (e, {value}) {
    this.setState({
      updatedPlan: value
    })
  }
  onDeviceCountSelection (e, {value}) {
    this.setState({
      updatedDeviceCount: value
    })
  }
  onPaymentMethodChange (e, {value}) {
    this.setState({
      updatedPaymentMethod: value
    })
  }
  componentWillReceiveProps (nextProps) {
    this.setState({
      updatedPlan: nextProps.plan,
      updatedDeviceCount: nextProps.deviceCount,
      updatedPaymentMethod: nextProps.paymentMethod
    })
  }
  render () {

    const planValues = [
      {key: 'free', value: 'free', text: 'Risqover free'},
      {key: 'plus', value: 'plus', text: 'Risqover plus'}
    ]
    const deviceCount = [
      {key: 10, value: 10, text: '10'},
      {key: 25, value: 25, text: '25'},
      {key: 50, value: 50, text: '50'}
    ]
    const paymentDuration = [
      {key: 'monthly', value: 'monthly', text: 'Monthly'},
      {key: 'yearly', value: 'yearly', text: 'Yearly'}
    ]
    const editForm = (
      <div>
        <Form id='editForm' loading={this.state.isLoading} onSubmit={this.onEditFormSubmit.bind(this)}>
          <Field>
            <label>Plan</label>
            <Dropdown
              placeholder='Select new plan'
              fluid selection
              options={planValues}
              onChange={this.onPlanSelection.bind(this)}
              defaultValue={this.props.plan}
            />
          </Field>

          <Field>
            <label>Device count</label>
            <Dropdown
              placeholder='Select device count'
              fluid selection
              options={deviceCount}
              disabled={this.state.updatedPlan === 'free'}
              onChange={this.onDeviceCountSelection.bind(this)}
              defaultValue={this.props.deviceCount}
            />
          </Field>

          <Field>
            <label>Payment method</label>
            <Dropdown
              placeholder='Select payment method'
              fluid selection
              disabled={this.state.updatedPlan === 'free'}
              options={paymentDuration}
              onChange={this.onPaymentMethodChange.bind(this)}
              defaultValue={this.props.paymentMethod}
            />
          </Field>
        </Form>
      </div>
    )
    const modal = (
      <Modal open={this.props.showPlanEdit} style={modalStyle} onClose={this.cancelEdit.bind(this)}>
        <Modal.Header style={{overflow: 'hidden'}}>
          Update Plan
          <a href='#'>
            <Image onClick={this.cancelEdit.bind(this)} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px'}} avatar src={'/icons/close_432859.svg'} />
          </a>
        </Modal.Header>

        <Modal.Content>
          <Modal.Description>
            {editForm}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button primary icon='check' content='Update' type='submit' form='editForm' />
        </Modal.Actions>
      </Modal>
    )
    return modal
  }
}

export default PlanEdit



// WEBPACK FOOTER //
// ./src/pages/settings/billing/components/plans/updateplan/index.js